var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datetime',{attrs:{"type":"datetime","use12-hour":"use12-hour","input-id":_vm.inputId,"hidden-name":_vm.inputName},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }